import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import VisuallyHidden from '@zenbusiness/zui/VisuallyHidden';

import useFlowState from '#client/hooks/flow/useFlowState';

import * as Styled from './AppHeader.style';
import ChatButton from '../ChatButton';
import Logo from '../Logo';
import PhoneButton from '../PhoneButton';
import UserInfo from '../UserInfo';

export default function AppHeader() {
  const { contactInfo, businessInfo } = useFlowState();
  const { authenticated } = useAuthentication();
  const { sizes } = useBreakpoints();
  const isMobile = !sizes.isDesktop;

  const businessName = businessInfo?.name;
  const firstName = contactInfo?.firstName;

  const loggedInUserLabel = businessName || firstName;

  const shouldShowUserInfo = authenticated && !!loggedInUserLabel;

  return (
    <Styled.Root>
      <Styled.Branding component={shouldShowUserInfo && isMobile ? VisuallyHidden : undefined}>
        <Logo />
      </Styled.Branding>

      <Styled.Actions fullWidth={shouldShowUserInfo}>
        {shouldShowUserInfo && <UserInfo isBusiness={!!businessName}>{loggedInUserLabel}</UserInfo>}
        <PhoneButton />
        <ChatButton />
      </Styled.Actions>
    </Styled.Root>
  );
}
